export default "__VITE_ASSET__8RO1SJ_A__"